import { useMemo } from 'react';

export const getRenderableSliders = (sliders = []) => (
  (Array.isArray(sliders) ? sliders : []).filter((slide) => (
    slide && typeof slide.image === 'string' && slide.image.trim().length > 0
  ))
);

export const isSlideImage = (slide) => {
  if ([false, 0, '0', 'false'].includes(slide?.isImage)) return false;
  if ([true, 1, '1', 'true'].includes(slide?.isImage)) return true;

  return !/\.(mp4|webm|ogg|mov)(?:$|[?#])/i.test(String(slide?.image || ''));
};

const noop = () => {};

export const useRenderableHeroSliders = (sliders = []) => {
  const heroSliders = useMemo(() => getRenderableSliders(sliders), [sliders]);

  return {
    heroSliders,
    markHeroSlideReady: noop,
    markHeroSlideFailed: noop,
  };
};
